import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import Button from '@helsenorge/designsystem-react/components/Button';
import styles from './styles.module.scss';
const SubContent = ({ countShowing, error, data, showMorePageSize, showMoreButtonClasses, showMoreButtonText, updateCountShowing, }) => {
    const subContentClasses = classnames({
        [styles['table__sub-content']]: true,
        [styles['table__sub-content--has-error']]: !!error,
    });
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: subContentClasses, children: !!error && _jsx("p", { children: `Temporary error msg: ${error.Title} ${error.Body}` }) }), showMorePageSize && countShowing && data && countShowing < data.length ? (_jsx(Button, { wrapperClassName: showMoreButtonClasses, onClick: updateCountShowing, children: showMoreButtonText })) : null] }));
};
export default SubContent;
